import Axios from "axios";
const getPage = async (OID) => {
    const response = await Axios.get(`api/v2/page/${OID}`, { baseURL: process.env.VUE_APP_API });
    const content = response.data;
    return content;
};
//const getImageContentTypeDOID = async () => {
//    const storedContentTypes = store.getters.contentTypes;
//    if (storedContentTypes && storedContentTypes.length > 0) {
//        return storedContentTypes;
//    }
//    const response = await Axios.get("api/v2/cms/doids/image", { baseURL: process.env.VUE_APP_API });
//    console.log(response.data);
//    return response.data;
//};
//const buildImageUrl = async (objDoid: string) => {
//    const path = `${process.env.VUE_APP_WEBCOMAND_API}com_webcomand/cache/img/${objDoid}D/image`;
//    return path;
//};
export { getPage };
